<template>
  <a href="/dashboard">
    <img class="logo" src="/icons/dashboard/rounded_artfield.png" alt="Logo dark">
  </a>
</template>

<style scoped>
.logo {
  width: 40px;
  height: 40px;
  margin: 10px 40px;
}
</style>
<script setup lang="ts">
</script>